export default "__VITE_ASSET__B2Y8o50Y__"